import { ChangeEvent } from "react";
import MenuItem from "@mui/material/MenuItem";
import Pagination from "@mui/material/Pagination";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { PO_COMPACT_MEDIA, PO_LIST_LIMIT_OPTIONS } from "./data";

interface PurchaseOrderPaginationProps {
  totalCount: number;
  page: number;
  limit: number;
  onChangePage: (page: number) => void;
  onChangeLimit: (limit: number) => void;
}

/** ตัวเลือกขนาดหน้า + ตัวเลือกหน้า ของรายการ PO ทั้ง W1 และ W7 */
export default function PurchaseOrderPagination({
  totalCount,
  page,
  limit,
  onChangePage,
  onChangeLimit,
}: PurchaseOrderPaginationProps) {
  const handleChangeLimit = (event: SelectChangeEvent<number>) => {
    onChangeLimit(Number(event.target.value));
  };

  const handleChangePage = (_event: ChangeEvent<unknown>, newPage: number) => {
    onChangePage(newPage);
  };

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{ p: 2, [PO_COMPACT_MEDIA]: { p: 1.5, flexWrap: "wrap", gap: 1 } }}
    >
      <Stack direction="row" alignItems="center" gap={2}>
        <Typography variant="body2">แสดง</Typography>
        <Select size="small" value={limit} onChange={handleChangeLimit}>
          {PO_LIST_LIMIT_OPTIONS.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
        <Typography variant="body2">รายการ</Typography>
      </Stack>
      <Pagination
        // รายการว่างต้องเหลือหน้าเดียว ไม่ใช่ศูนย์หน้า (MUI จะไม่วาดปุ่มเลย)
        count={Math.max(1, Math.ceil(totalCount / limit))}
        page={page}
        onChange={handleChangePage}
        color="primary"
        variant="outlined"
        shape="rounded"
      />
    </Stack>
  );
}
